var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomepageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.8V7.02395C16 6.69581 15.839 6.38854 15.5692 6.20176L10.0692 2.39407C9.72676 2.15699 9.27323 2.15699 8.93079 2.39407L3.43079 6.20176C3.16099 6.38854 3 6.69581 3 7.02395V15.8C3 15.9105 3.08954 16 3.2 16H7.35C7.46046 16 7.55 15.9105 7.55 15.8V12.5204C7.55 12.2442 7.77386 12.0204 8.05 12.0204H10.95C11.2261 12.0204 11.45 12.2442 11.45 12.5204V15.8C11.45 15.9105 11.5395 16 11.65 16H15.8C15.9105 16 16 15.9105 16 15.8Z",
    stroke: "#1A1B1D",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageIcon);
export default __webpack_public_path__ + "static/media/homepage-icon.5e2277e806e4c176bff169e5811b3311.svg";
export { ForwardRef as ReactComponent };